import 'lightgallery.js/dist/css/lightgallery.min.css';
import Lightbox from 'stimulus-lightbox';
export default class extends Lightbox {
    get defaultOptions() {
        return {
            download: false,
        };
    }
}
